import { Component, inject, signal, viewChild } from '@angular/core';
import { Log } from '../../utils/models/tool.models';
import { JobLogsDialComponent } from '../../utils/dialogues/job-logs-dial/job-logs-dial.component';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from '../../services/loading/loader.service';
import { ToolchainService } from '../../services/api-services/toolchains/toolchain.service';
import { FileUploadComponent } from '../../utils/execution-form/file-upload/file-upload.component';
import { MatIcon } from '@angular/material/icon';
import { MatError } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { SpinnerComponent } from '../../utils/spinner/spinner.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-toolchain-installation',
  templateUrl: './toolchain-installation.component.html',
  styleUrl: './toolchain-installation.component.scss',
  imports: [FileUploadComponent, MatIcon, MatError, MatButton, SpinnerComponent],
})
export class ToolchainInstallationComponent {
  /** Inject services. */
  private readonly toolchainService = inject(ToolchainService);
  private readonly loader = inject(LoaderService);
  private readonly dialogRef = inject(MatDialog);

  readonly fileUploadComponent = viewChild.required(FileUploadComponent);
  selectedFile = signal<File | null>(null);
  logs = signal<Log | null>(null);
  isUploadStarted = signal(false);
  isUploadSuccessful = signal(false);

  onFileSelect(event: File[]) {
    this.selectedFile.set(event[0]);
  }

  async installToolchain() {
    this.loader.setLoading(true);
    const selectedFile = this.selectedFile();
    if (!selectedFile) {
      console.warn('No file selected');
      return;
    }

    const formData = new FormData();
    formData.append('toolchain-config', selectedFile);

    try {
      this.logs.set(await this.toolchainService.uploadToolchain(formData));
      this.selectedFile.set(null);
      this.fileUploadComponent().resetInput();
      this.isUploadSuccessful.set(true);
      this.isUploadStarted.set(true);
    } catch (error) {
      if (error instanceof HttpErrorResponse) {
        this.logs.set(error.error ?? ['No data from backend provided.']);
      } else {
        throw error;
      }
      this.isUploadSuccessful.set(false);
      this.isUploadStarted.set(true);
    }
  }

  openLogs() {
    this.dialogRef.open(JobLogsDialComponent, {
      data: this.logs,
    });
  }
}
